import { Draggable, Droppable } from '@hello-pangea/dnd';
import { transportationKeys } from '../../../../../../../consts/conditions';
import { useMemo } from 'react';

import ConditionBody from '../ConditionBody';
import ConditionalInput from '../ConditionalInput';
import classNames from 'classnames';
import ConditionBtnWithLine from '../ConditionBtnWithLine';
import AddFilterBtn from '../AddFilterBtn';
import FilterColumnCard from '../FilterColumnCard';
import ReplaceIcon from '../../../../../../../assets/icons/replace.svg?react';
import styled from 'styled-components';
import { Box, Flex, Input, Radio, rem, Text } from '@mantine/core';
import { BiInfoCircle } from 'react-icons/bi';

const getMonthsCount = period => {
  switch (period) {
    case 'Q1':
    case 'Q2':
    case 'Q3':
    case 'Q4':
      return 3;

    case 'H1':
    case 'H2':
      return 6;

    case 'X1':
    case 'X2':
      return 9;

    case 'Y1':
      return 12;
  }
};

export const SplitColumn = ({
  isChildrenGroup,
  cuurentItem,
  filterTypes,
  onChangeOperator,
  onChangeThenInputType,
  onChangeThen,
  onSelectItem,
  onSelectCondition,
  parentFilterTypeId,
  addCondition,
  onChangeReplaceColumn,
  selectedItems,
  onDeleteSelectedItems,
  onChangeFunction,
  onChangeInputType,
  onChangeInput,
  onChangeColumn,
  columns,
  changeColumnsCount,
  onChangeSingleColumn,
  onChangeElseInputType,
  periodName
}) => {
  const _columns = useMemo(() => cuurentItem?.columns, [cuurentItem?.columns]);

  const handleChangeCount = e => {
    changeColumnsCount(cuurentItem?.id, cuurentItem?.id, e.target?.value);
  };

  const removeNotAllowed = filterTypes?.[0]?.conditions?.length === 1;

  const handleChangeColumn = (e, idx) => {
    onChangeSingleColumn(cuurentItem?.id, cuurentItem?.id, idx, e.target?.value);
  };

  const handleChangeSplitType = val => {
    if (val === 'datetime') {
      const monthsCount = getMonthsCount(periodName);

      onChangeElseInputType(cuurentItem?.id, cuurentItem?.id, val);
      handleChangeCount({ target: { value: monthsCount } });
      return;
    }

    onChangeElseInputType(cuurentItem?.id, cuurentItem?.id, val);
  };

  return (
    <>
      <div id="grid-table-split-column-root" className="condition-box">
        <div id="grid-table-split-column-list" className="filter-types">
          <Droppable droppableId={cuurentItem?.id} key={cuurentItem?.id}>
            {provided =>
              filterTypes
                .filter(item => item.conditions?.length > 0)
                .map((item, idx) => {
                  const filterTypeId = parentFilterTypeId || item.id;

                  return (
                    <div
                      key={item.id}
                      {...provided.droppableProps}
                      style={{ width: '100%' }}
                      ref={provided.innerRef}
                    >
                      <div
                        className={classNames('filter_card', {
                          ['isChildren']: isChildrenGroup,
                          ['noBorderTop']: true,
                          ['noBorderBottom']: true,
                          ['isFilter']: true
                        })}
                      >
                        <div id={`grid-table-split-column-item-${idx}`} className="filter_content">
                          <ConditionBtnWithLine
                            id={`grid-table-split-column-condition-${item.id}`}
                            label={item.conditionLabel}
                            onClickDelete={() => onDeleteSelectedItems(filterTypeId)}
                            disableDelete={!selectedItems?.length > 0 || removeNotAllowed}
                            disableGroup={true}
                            withActions={!isChildrenGroup && idx === 0 && filterTypes?.length > 0}
                            onSelectCondition={val => onSelectCondition(filterTypeId, val, item.id)}
                          />

                          {item?.conditions?.map((value, idx) => {
                            if (value?.conditions?.length > 0)
                              return (
                                <Draggable key={value.id} draggableId={value.id} index={idx}>
                                  {(dragProvided, dragSnapshot) => {
                                    return (
                                      <div
                                        key={value.id}
                                        className="group-wrapper"
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        style={{
                                          ...dragProvided.draggableProps.style,
                                          width: '100%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                          opacity: dragSnapshot.isDragging ? 0.5 : 1
                                        }}
                                      >
                                        <div
                                          id={`grid-table-split-column-group-checkbox-${value.id}`}
                                          className="checkbox_line"
                                        >
                                          <input
                                            id={`grid-table-split-column-group-checkbox-input-${value.id}`}
                                            type="checkbox"
                                            className="checkbox"
                                            checked={selectedItems.includes(value.id)}
                                            onClick={() => onSelectItem(value.id)}
                                          />
                                        </div>

                                        <ConditionBody
                                          cuurentItem={value}
                                          filterTypes={[value]}
                                          selectedItems={selectedItems}
                                          onSelectItem={onSelectItem}
                                          addCondition={addCondition}
                                          isChildrenGroup={true}
                                          columns={columns}
                                          parentFilterTypeId={
                                            !isChildrenGroup ? filterTypeId : parentFilterTypeId
                                          }
                                          onChangeInput={onChangeInput}
                                          onChangeColumn={onChangeColumn}
                                          onChangeFunction={onChangeFunction}
                                          onChangeOperator={onChangeOperator}
                                          onChangeInputType={onChangeInputType}
                                          onSelectCondition={onSelectCondition}
                                        />

                                        <div
                                          id={`grid-table-split-column-group-replace-${value.id}`}
                                          className="replace-btn"
                                          {...dragProvided.dragHandleProps}
                                        >
                                          <ReplaceIcon />
                                        </div>
                                      </div>
                                    );
                                  }}
                                </Draggable>
                              );

                            return (
                              <Draggable key={value.id} draggableId={value.id} index={idx}>
                                {(dragProvided, dragSnapshot) => (
                                  <div
                                    id={`grid-table-split-column-row-${value.id}`}
                                    key={value.id}
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      opacity: dragSnapshot.isDragging ? 0.5 : 1
                                    }}
                                  >
                                    <FilterColumnCard
                                      id={`grid-table-split-column-card-${value.id}`}
                                      key={value.id}
                                      operator={value.operator}
                                      column={value.column}
                                      func={value.function}
                                      value={value.value}
                                      inputType={value.inputType}
                                      columns={columns}
                                      errors={value.errors}
                                      dragHandleProps={{
                                        ...dragProvided.dragHandleProps
                                      }}
                                      hideFunction={true}
                                      showDate={false}
                                      isSelected={selectedItems.includes(value.id)}
                                      onSelect={() => onSelectItem(value.id)}
                                      onChangeFunction={val =>
                                        onChangeFunction(filterTypeId, value.id, val)
                                      }
                                      onChangeInputType={val =>
                                        onChangeInputType(filterTypeId, value.id, val)
                                      }
                                      onChangeColumn={val =>
                                        onChangeColumn(filterTypeId, value.id, val)
                                      }
                                      onChangeOperator={val =>
                                        onChangeOperator(filterTypeId, value.id, val)
                                      }
                                      onChangeInput={val =>
                                        onChangeInput(filterTypeId, value.id, val)
                                      }
                                    />
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}

                          {provided.placeholder}

                          <AddFilterBtn
                            id={`grid-table-split-column-add-${item.id}`}
                            onClick={type =>
                              addCondition(item.id, type, parentFilterTypeId || filterTypeId)
                            }
                          />
                        </div>

                        {!isChildrenGroup &&
                          (cuurentItem || item).label === transportationKeys.REPLACE && (
                            <div id="grid-table-split-column-then" className="then">
                              <p
                                id="grid-table-split-column-then-label"
                                style={{ marginTop: '17px' }}
                              >
                                Then
                              </p>
                              <ConditionalInput
                                id="grid-table-split-column-then-input"
                                hideFunction={true}
                                columns={columns}
                                value={item?.then[item?.thenInputType]}
                                hideVariants={['ai_input']}
                                type={item?.thenInputType}
                                onChangeType={val =>
                                  onChangeThenInputType(filterTypeId, item.id, val)
                                }
                                onChangeValue={val => onChangeThen(filterTypeId, item.id, val)}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  );
                })
            }
          </Droppable>
        </div>
      </div>

      <SplitContainer>
        <Text size={rem(14)} c="#868E96" fw={400} py={rem(16)}>
          Split specific row into N rows based on the filter condition and provide values for each
          split in result column
        </Text>

        <div className="container">
          <div className="box">
            <div className="counter">
              <Flex gap={rem(8)}>
                <Flex direction="column">
                  <Text size={rem(12)} fw={600}>
                    Split Into<span className="required">*</span>{' '}
                  </Text>

                  <Input
                    id="grid-table-split-column-count-input"
                    mt={rem(8)}
                    size="xs"
                    type="number"
                    min={0}
                    value={_columns?.length}
                    disabled={cuurentItem?.elseInputType === 'datetime'}
                    onChange={handleChangeCount}
                  />
                </Flex>

                <Flex direction="column" h="100%">
                  <label className="input">
                    <Text size={rem(12)} fw={600}>
                      Split Type
                    </Text>

                    <Flex gap={rem(8)} mt={rem(16)}>
                      <Radio
                        id="grid-table-split-column-split-input-radio"
                        label="Input"
                        size="xs"
                        value="input"
                        checked={cuurentItem.elseInputType === 'input'}
                        onChange={({ target: { value } }) => handleChangeSplitType(value)}
                      />
                      <Radio
                        id="grid-table-split-column-split-date-radio"
                        label="Date"
                        size="xs"
                        value="datetime"
                        checked={cuurentItem.elseInputType === 'datetime'}
                        onChange={({ target: { value } }) => handleChangeSplitType(value)}
                      />
                    </Flex>
                  </label>
                </Flex>
              </Flex>

              <Box
                bd="1px solid #228BE6"
                p={rem(12)}
                style={{ borderRadius: rem(4) }}
                display="flex"
                mt={rem(16)}
              >
                <BiInfoCircle color="#228BE6" size={16} style={{ minWidth: 16 }} />

                <Text size={rem(14)} c="#25262B" fw={400} ml={rem(16)}>
                  Selected date ranges will be applied in the upcoming reporting periods
                  accordingly.
                </Text>
              </Box>
            </div>

            <div className="columns">
              {_columns?.map((col, idx) => (
                <label className="input" key={idx}>
                  <Text size={rem(12)} fw={600}>
                    {idx + 1}-split name<span className="required">*</span>
                  </Text>

                  <Input
                    id={`grid-table-split-column-name-input-${idx}`}
                    mt={rem(4)}
                    size="xs"
                    value={col}
                    min={0}
                    onChange={e => handleChangeColumn(e, idx)}
                    placeholder="Input"
                    disabled={cuurentItem?.elseInputType === 'datetime'}
                  />
                </label>
              ))}
            </div>
          </div>

          <div className="result">
            <Flex gap={rem(4)} direction="column" align="flex-start">
              <Text size={rem(12)} fw={600}>
                Result Column <span className="required">*</span>
              </Text>

              <ConditionalInput
                columns={columns}
                value={cuurentItem?.replaceColumn}
                hasRequiredError={cuurentItem?.errors?.includes('replaceColumn')}
                onChangeValue={val => onChangeReplaceColumn(cuurentItem?.id, cuurentItem?.id, val)}
                hiddenVariants={['null', 'input', 'column', 'ai_input']}
              />
            </Flex>
          </div>
        </div>
      </SplitContainer>
    </>
  );
};

const SplitContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 8px 0;
  border-top: 1px solid #cdd4df;

  .required {
    color: red !important;
  }

  .header {
    p {
      color: #2b313d;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }

  .container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 16px;

    .box {
      border: 1px solid #ced4da;
      border-radius: 8px;
      padding: 8px;
      flex: 1;
      display: flex;
      flex-direction: column;

      .counter {
        width: 100%;
        border-bottom: 1px solid #f1f3f5;
        padding-bottom: 16px;
      }

      .columns {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        padding: 16px 0;

        .input {
          width: calc(50% - 4px);
        }
      }
    }

    .result {
      width: 140px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
`;
